import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import AutomatedSlider from "../utils/auto-slider";

import * as I from "../utils/icons";

export function SliderStyled({ children }) {
	return <AutomatedSlider class="scrollbar-x-fancy">{children}</AutomatedSlider>;
}

export function ScrollContent({ children }) {
	return <div class="flex gap-3 font-roboto mb-1">{children}</div>;
}

export function WidgetCard({ children }) {
	return <div class="rounded-lg overflow-hidden bg-sky-300 bg-img-sky-ball bg-cover text-slate-950 font-bold w-80 shrink-0 text-sm">{children}</div>;
}

export function WidgetCardTop({ children }) {
	return (
		<div class="fn-top-image h-28 bg-widget-soccer bg-cover bg-top text-center flex flex-col justify-between">
			{children}
		</div>
	);
}
export function WidgetCardBottom({ children }) {
	return (
		<div class="fn-event-info h-24 flex flex-col p-2 bg-[color:var(--betstable-main-cell)] justify-between">
			{children}
		</div>
	);
}

export function TournamentName({ children }) {
	return <div class="fn-tournament">{children}</div>;
}
export function TeamIcons({ children }) {
	return <div class="fn-icons flex gap-5 justify-center">{children}</div>;
}
export function TeamIconContainer({ children }) {
	return <div class="">{children}</div>;
}
export function TeamIcon({ src }) {
	return <img class="h-12" src={src} />;
}
export function TeamIconXs({ src }) {
	return <img class="h-4" src={src} />;
}
export function StartDate({ children }) {
	return <div class="fn-start-date">{children}</div>;
}

export function MatchName({ children }) {
	return <div class="fn-event-name flex gap-1">{children}</div>;
}
export function TeamName({ children }) {
	return <div class="shrink w-1/2 text-center truncate">{children}</div>;
}
export function Versus({}) {
	return <div>vs.</div>;
}

export function OddsContainer({ children }) {
	return <div class="fn-event-odds flex justify-between gap-1 py-2">{children}</div>;
}






export function QuickbetPanel({ children, refFn }) {
	return (
		<div class="panel relative mb-3" ref={refFn}>
			{children}
		</div>
	);
}
export function QuickbetHeader({ children }) {
	return <h4 class="flex items-center justify-between panel h-10 bg-kobaaccent-400 text-slate-950 rounded-t-xl overflow-hidden">{children}</h4>;
}
export function Title({ children }) {
	return <span class="panel-flex-title px-3 uppercase">{children}</span>;
}
export function QbetBadge({ children }) {
	return <div class="body-bg-color">{children}</div>;
}
export function QbetLink({ children, onClick }) {
	return (
		<a
			href="javascript:void(0);"
			onClick={onClick}
			class="button-minimal text-xs font-bold rounded leading-6 px-2 whitespace-pre"
		>
			{children}
		</a>
	);
}
export function QuickbetForm({ children, id, onSubmit }) {
	return (
		<form id={id} onSubmit={onSubmit}>
			{children}
		</form>
	);
}
export function CurrentEventRow({ children }) {
	return <div class="main-text-color text-xs text-center block truncate p-1 bg-slate-100 text-slate-950 border-b border-b-slate-300">{children}</div>;
}
export function CancelSelection({ onClick }) {
	return (
		<a href="javascript:void(0);" onClick={onClick} class="inline-block mr-2">
			<I.CloseIcon class="h-2 text-red-500" />
		</a>
	);
}
export function CurrentEventName({ children }) {
	return <span class="inline-block text-sm">{children}</span>;
}
export function CurrentMarketRow({ children }) {
	return <div class="block text-sm main-color">{children}</div>;
}
export function Highlight({ children }) {
	return <span class="main-text-color font-bold">{children}</span>;
}
export function QuickbetInputs({ children }) {
	return <div class="p-3 flex gap-1 bg-slate-100 text-slate-950 rounded-b-xl">{children}</div>;
}

export function QuickbetMatchInput({ id, type, onInput, onFocus, value, placeholder, active, ...props }) {
	if (active)
		return (
			<input
				class={"main-content-form-element text-sm rounded-lg bg-slate-300 block w-full rounded w-2/5 p-1 text-slate-700 " + props.class}
				{...{ id, type, onInput, onFocus, value, placeholder }}
				disabled={false}
			/>
		);
	return (
		<input
			class={"main-content-form-element text-sm block w-full rounded w-2/5 p-1 bg-slate-300" + props.class}
			{...{ id, type, value, placeholder }}
			disabled={true}
		/>
	);
}
export function Tooltip({ children, id, onMouseOver, onMouseOut }) {
	return (
		<div
			{...{ id, onMouseOver, onMouseOut }}
			style="min-width:350px"
			class="prematch-event-selection overflow-auto absolute right-0 top-18 rounded bg-slate-100 text-slate-950 border border-slate-500 z-10"
		>
			{children}
		</div>
	);
}
export function MatchEntry({ children, id, onClick, active }) {
	const self = useRef();
	useEffect(() => {
		if (active)
			self.current.scrollIntoView(false);
	}, [active]);

	return (
		<a
			href="javascript:void(0);"
			id={id}
			ref={self}
			onClick={onClick}
			data-current={active}
			class="prematch-event-item block px-3 py-2 font-normal border-b data-[current=true]:border-red-500 data-[current=true]:border-2"
		>
			{children}
		</a>
	);
}
export function MatchEntryTopRow({ children }) {
	return <div class="block leading-4">{children}</div>;
}
export function MatchEntryBottomRow({ children }) {
	return <div class="block leading-4">{children}</div>;
}
export function EntryMatchName({ children }) {
	return <span class="inline-block main-text-color leading-4">{children}</span>;
}
export function MatchTournament({ children }) {
	return <span class="inline-block text-xxs leading-4">{children}</span>;
}
export function DashSeparator({}) {
	return <span class="inline-block mx-2 leading-4">-</span>;
}
export function MatchDate({ children }) {
	return <span class="inline-block leading-4">{children}</span>;
}
export function EmptySelect() {
	return (
		<select class="main-content-form-element rounded-lg text-sm block w-full rounded p-1 bg-slate-300" disabled={true}>
			<option>...</option>
		</select>
	);
}

